import { AxiosInstance } from "axios";
import Endpoint from "@/utils/endpoint";
import NewInterface, { newInitialValue } from "@/types/app/news";
import ErrorService from "./erroService";
import ResultResponseInterface from "@/types/app/resultResponse";

export default class NewService {

  constructor(private api: AxiosInstance, private endpoint: Endpoint = new Endpoint()) { }

  async getNews(): Promise<NewInterface[]> {

    try {
      const { data } = await this.api.get<NewInterface[]>(`${this.endpoint.news}`);
      return data;
    } catch (error) {
      ErrorService.onError(error);
      return [];
    }

  }

  async getNewsById(newId:string): Promise<NewInterface> {

    try {
      const { data } = await this.api.get<NewInterface>(`${this.endpoint.news}/${newId}`);
      return data;
    } catch (error) {
      ErrorService.onError(error);
      return newInitialValue;
    }

  }

  async deleteNew(newIds: string[]): Promise<ResultResponseInterface> {
    try {
      const { data } = await this.api.delete(`${this.endpoint.news}`, {
        data: { newIds },
      });
      return data;
    } catch (error) {
      return ErrorService.onError(error);
    }
  }

  async saveNews(news: FormData, newId:string, edit: boolean): Promise<ResultResponseInterface> {
    try {
      const { data } = !edit ? await this.api.post(this.endpoint.news, news) : await this.api.put(`${this.endpoint.news}/${newId}`, news);
      return data;
    } catch (error) {
      
      return ErrorService.onError(error);
    }
  }

  async publishedNews(newId: string): Promise<ResultResponseInterface> {
    try {
      const { data } = await this.api.put(`${this.endpoint.newspublished}`, { newId });
      return data;
    } catch (error) {
      return ErrorService.onError(error);
    }
  }
}